// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"906792f8","453":"5e914a6b","610":"e971ad2e","767":"e7843c86","891":"7581290e"}[chunkId] + ".chunk.js";
};